import React from 'react';
import { Button } from "@blueprintjs/core";

class SearchNhomHoSo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tenNhomFile: this.props.parents.state.tenNhomFile
    }
  }

  handleSearch(e) {
    e.preventDefault();
    this.props.parents.handleSearch();
  }

  handleChange(e) {
    this.setState({
      tenNhomFile: e.target.value
    })
    let data = {
      target: {
        name: 'tenNhomFile',
        value: e.target.value
      }
    }
    this.props.parents.handleChange(data)
  }

  render() {
    return (
      <section className="wrap-block search-container">
        <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
          <input
            type="text"
            name="tenNhomFile"
            placeholder="Nhập"
            className="search-input"
            value={this.state.tenNhomFile}
            onChange={this.handleChange.bind(this)}
          />
          <Button
            type="submit"
            text="Tìm kiếm"
            className={this.props.parents.state.tableLoading ? (this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"}
          />
        </form>
      </section>
    );
  }
}

export default SearchNhomHoSo;



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-ho-so/SearchNhomHoSo.jsx